/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-12-07 15:09:36
 * @LastEditors: linxi
 * @LastEditTime: 2024-10-28 09:42:03
 */
import React from 'react'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { api, sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  adlopuuploadAsync,
  AdlopuuploadParams,
  medicalRecordList,
  MedicalRecordParams,
  uploadRequestStringAsync,
  UploadRequestStringParams,
} from '../../../services/HealthSupervisorUpload'

export const getMedicalRecordListAsync = createAsyncThunk<
  void,
  MedicalRecordParams,
  RootThunkApi
>('payment/getOweMoneyDetail', async (params, api) => {
  return sendAsync(medicalRecordList(params), api)
})

// 后端上传、
export const getAdlopuuploadAsync = createAsyncThunk<
  void,
  AdlopuuploadParams,
  RootThunkApi
>('payment/getAdlopuuploadAsync', async (params, api) => {
  return sendAsync(adlopuuploadAsync(params), api)
})

export const getUploadRequestStringAsync = createAsyncThunk<
  void,
  UploadRequestStringParams,
  RootThunkApi
>('payment/getUploadRequestStringAsync', async (params, api) => {
  return sendAsync(uploadRequestStringAsync(params), api)
})


